<template>
  <div>
    <v-row
      class="prize-item prize-card-item"
      v-for="prize in prizes.entries.filter(x => Boolean(x.amount))"
      :key="prize.identifier"
      no-gutters
    >
      <v-col md="6" class="next-drawing-text prize-name">
        {{ prize.name }} - 1X :</v-col
      >
      <v-col md="6" class="amount">
        <span> {{ prize.amount }} </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "PrizesCard",
  inject: ["contentStatus"],
  props: {
    prizes: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "css/variables";
/*@import "css/main";*/

.prize-item {
  font-family: "RobotoBlack", serif;
  font-size: 1.6rem;
  line-height: 1.6rem;
  font-weight: bold;

  .amount {
    font-size: 1.9rem;
    color: $blue;
    width: 200px;
    height: 50px;
    align-items: center;
    justify-content: center;
    font-family: "DonJose", "Liberation Sans Narrow", serif;
    display: flex;
  }
}

.prize-card-item {
  background-color: white;
  padding-left: 15px;
  border-radius: 15px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.justify-content-space-evenly {
  justify-content: space-evenly;
}

.next-drawing-text {
  color: $darkblue;
}

.prize-name {
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>
